import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getResolvedPath } from '../../../../../../../../../../../util/routing/entity-paths';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-cash-transactions-${params.accountId}`,
        label: 'Cash & Equivalents',
        to: getResolvedPath('/registration/account/$accountId/cash/transaction', params),
      }),
    }) satisfies AggregateBreadcrumb,
});
